import React from "react";
import "./ToggleButton.scss";

const ToggleButton = ({ isOn, onToggle, label, status }) => {
  return (
    <label
      className={`toggle-button ${
        isOn ? "toggle-button--on" : "toggle-button--off"
      } ${status ? "toggle-button--disabled" : "toggle-button--enabled"}`}
    >
      <input type="checkbox" checked={isOn} onChange={onToggle} />
      <span className="toggle-button__slider">
        <span
          className={`toggle-button__label ${
            isOn ? "toggle-button__label--on" : "toggle-button__label--off"
          }`}
        >
          {isOn ? "Enabled" : "Disabled"}
        </span>
      </span>
    </label>
  );
};

export default ToggleButton;
